import { useCallback, useEffect, useRef, useState } from 'react';

const INITIAL = { status: 'idle', error: '', muted: false, speaking: false, thinking: false,
  sessionId: '', remaining: 0, playbackBlocked: false, reason: '' };
export const ENDED_VOICE_STATE = { status: 'ended', muted: false, speaking: false, thinking: false };

export function useVoiceState() {
  const [state, setState] = useState(INITIAL);
  const mounted = useRef(true);
  useEffect(() => {
    mounted.current = true;
    return () => { mounted.current = false; };
  }, []);
  const update = useCallback(patch => {
    if (mounted.current) setState(previous => ({ ...previous, ...patch }));
  }, []);
  const resetState = useCallback(() => setState(INITIAL), []);
  return { state, update, resetState, mounted };
}